@if (activeBanners?.length) {
  <div #slides class="slide-track">
    @if (activeBanners.length > 1 && activeBanners[prevSlide]; as slide) {
      <div class="slide">
        @if (slide.videoSrc) {
          <video loop [muted]="true" preload="auto">
            <source [src]="slide.videoSrc" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        }
        <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: slide, cmsQuality: 25 }"></ng-container>
      </div>
    }

    @let slide = activeBanners[currentSlide | async];
    <div class="slide" [class.single-banner]="activeBanners.length === 1">
      @if (slide.videoSrc) {
        <video #player loop playsinline [muted]="true" autoplay preload="auto">
          <source [src]="slide.videoSrc" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      }
      <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: slide, cmsQuality: 75 }"></ng-container>
    </div>
    @if (activeBanners.length > 1 && activeBanners[nextSlide]; as slide) {
      <div class="slide">
        @if (slide.videoSrc) {
          <video loop [muted]="true" preload="auto">
            <source [src]="slide.videoSrc" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        }
        <ng-container [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: slide, cmsQuality: 25 }"></ng-container>
      </div>
    }
  </div>
}
@if (activeBanners?.length > 1) {
  <app-icon-button class="prev" [icon]="arrowIcon" (click)="selectSlide('prev')"></app-icon-button>
  <app-icon-button class="next" [icon]="arrowIcon" (click)="selectSlide('next')"></app-icon-button>
}

<ng-template #contentTemplate let-slide let-cmsQuality="cmsQuality">
  @if (!slide.textboxPlacement && slide.textboxPlacement !== 0) {
    @if (slide.link) {
      @let sameSiteLink = sameSite(slide.link);
      @if (sameSiteLink) {
        <a [routerLink]="sameSiteLink" [target]="slide.target">
          @if (slide.image) {
            <img
              [ngSrc]="isMobile && slide.mobileImage ? slide.mobileImage : slide.image"
              [alt]="slide.title"
              priority
              fill
              sizes="100vw"
            />
          }
          @if (slide.title) {
            <span class="title link">
              <h2>{{ slide.title }}</h2>
              @if (slide.subtitle) {
                <span class="subtitle">{{ slide.subtitle }}</span>
              }
            </span>
          }
        </a>
      }
      @if (!sameSiteLink) {
        <a [href]="slide.link" [target]="slide.target">
          @if (slide.image) {
            <img
              [ngSrc]="isMobile && slide.mobileImage ? slide.mobileImage : slide.image"
              [alt]="slide.title"
              priority
              fill
              sizes="100vw"
            />
          }
          @if (slide.title) {
            <span class="title link">
              <h2>{{ slide.title }}</h2>
              @if (slide.subtitle) {
                <span class="subtitle">{{ slide.subtitle }}</span>
              }
            </span>
          }
        </a>
      }
    }
    @if (!slide.link && slide.image) {
      <img [ngSrc]="isMobile && slide.mobileImage ? slide.mobileImage : slide.image" [alt]="slide.title" priority fill sizes="100vw" />
    }
    @if (slide.title && !slide.link) {
      <span class="title">
        <h2>{{ slide.title }}</h2>
        @if (slide.subtitle) {
          <span class="subtitle">{{ slide.subtitle }}</span>
        }
      </span>
    }
  }

  @if (slide.textboxPlacement || slide.textboxPlacement === 0) {
    <img class="textbox-img" [src]="isMobile && slide.mobileImage ? slide.mobileImage : slide.image" alt="" priority fill sizes="100vw" />
    <div class="textbox-wrapper" [ngClass]="textboxPlacementClass[slide.textboxPlacement]">
      <div class="textbox">
        @if (slide.title) {
          <h1>{{ slide.title }}</h1>
        }
        @if (slide.link) {
          @let sameSiteLink = sameSite(slide.link);
          @if (sameSiteLink && slide.target === '_self') {
            <app-text-button [routerLink]="sameSiteLink">
              {{ slide.textboxButton }} <mat-icon svgIcon="arrow_forward"></mat-icon>
            </app-text-button>
          }
          @if (!sameSiteLink || slide.target !== '_self') {
            <app-text-button [href]="slide.link" [target]="slide.target">
              {{ slide.textboxButton }} <mat-icon svgIcon="arrow_forward"></mat-icon>
            </app-text-button>
          }
        }
      </div>
    </div>
  }
</ng-template>
